import { Component, EventEmitter, Input, Output } from '@angular/core';

type TUploadResponseDTO = {
  totalProcessedRows: number;
  successfulRows: number;
  failedRows: number;
  errors: number;
  errorFileKeyOpt?: string;
  errorMessageOpt?: string;
};

@Component({
  selector: 'ui-upload-file-summary',
  templateUrl: './upload-file-summary.component.html',
  styleUrls: ['./upload-file-summary.component.scss'],
})
export class UploadFileSummaryComponent {
  @Input() summary: TUploadResponseDTO = {
    totalProcessedRows: 0,
    successfulRows: 0,
    failedRows: 0,
    errors: 0,
    errorFileKeyOpt: 'sada',
  };

  @Output() downloadErrorFileEvent = new EventEmitter<boolean>();

  onDownloadErrorFile() {
    this.downloadErrorFileEvent.emit(true);
  }
}
